import { CSSObject } from "@emotion/react";

import { NAVBAR_BREAKPOINTS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";

export const condensedPopoutSearchBarVisibilityCss: CSSObject = {
  position: "relative",
  width: "100%",

  [`@media (min-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    display: "none",
  },
};

export const condensedInputContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: "0.5rem",
  padding: "0.5rem",
  alignItems: "center",

  [`@media (min-width: ${NAVBAR_BREAKPOINTS.sm}px)`]: {
    display: "none",
  },
};

export const condensedCloseButtonCss = {
  root: {
    borderRadius: "0.5rem",
    padding: "0.25rem",

    ":hover": {
      background: "rgba(29, 29, 29, 0.08)",
    },
  },
};

export const condensedSearchCloseIconCss = {
  root: {
    width: "2rem",
    height: "2rem",
  },
};
